import { ChangeDetectionStrategy, Component, computed, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';

@Component({
  selector: 'cam-bakim-edit',
  standalone: true,
  imports: [FormsModule, NzInputModule, NzInputNumberModule, NzSelectModule, NzDatePickerModule,
    CdkTextareaAutosize],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="se">
      <div class="se-baslik">
        <div class="se-baslik-ikon" style="background:linear-gradient(135deg,#389e0d,#52c41a)">🔧</div>
        <span>Bakım Kaydı</span>
      </div>
      <div class="se-form">
        <div class="form-grup">
          <label>Bakım Türü <span class="zorunlu">*</span></label>
          <div class="input-wrap">
            <nz-select [ngModel]="p()?.bakimTuru" (ngModelChange)="guncelle('bakimTuru', $event)"
              nzPlaceHolder="Bakım türü seçin..." nzAllowClear nzShowSearch style="width:100%">
              <nz-option nzValue="Periyodik Bakım" nzLabel="Periyodik Bakım" nzCustomContent><span style="display:inline-flex;align-items:center;gap:6px"><span class="sel-dot" style="background:#52c41a"></span> Periyodik Bakım</span></nz-option>
              <nz-option nzValue="Arıza Bakım" nzLabel="Arıza Bakım" nzCustomContent><span style="display:inline-flex;align-items:center;gap:6px"><span class="sel-dot" style="background:#ff4d4f"></span> Arıza Bakım</span></nz-option>
              <nz-option nzValue="Revizyon" nzLabel="Revizyon" nzCustomContent><span style="display:inline-flex;align-items:center;gap:6px"><span class="sel-dot" style="background:#1890ff"></span> Revizyon</span></nz-option>
              <nz-option nzValue="Kalibrasyon" nzLabel="Kalibrasyon" nzCustomContent><span style="display:inline-flex;align-items:center;gap:6px"><span class="sel-dot" style="background:#722ed1"></span> Kalibrasyon</span></nz-option>
              <nz-option nzValue="Yağlama" nzLabel="Yağlama" nzCustomContent><span style="display:inline-flex;align-items:center;gap:6px"><span class="sel-dot" style="background:#fa8c16"></span> Yağlama</span></nz-option>
              <nz-option nzValue="Diğer" nzLabel="Diğer" nzCustomContent><span style="display:inline-flex;align-items:center;gap:6px"><span class="sel-dot" style="background:#8c8c8c"></span> Diğer</span></nz-option>
            </nz-select>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="se-ayirici"></div>

        <div class="form-satir">
          <div class="form-grup" style="flex:0 0 160px">
            <label>Makine Saati</label>
            <div class="input-wrap">
              <nz-input-number [ngModel]="p()?.makineSaati || null" (ngModelChange)="guncelle('makineSaati', $event)"
                [nzMin]="0" [nzStep]="1" nzPlaceHolder="Saat" style="width:100%"></nz-input-number>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup" style="flex:1">
            <label>Bakımcı</label>
            <div class="input-wrap">
              <input nz-input autocomplete="off"
                [ngModel]="p()?.bakimci || ''" (ngModelChange)="guncelle('bakimci', $event)"
                placeholder="Bakımcı adı..."/>
              <div class="input-glow"></div>
            </div>
          </div>
        </div>

        <div class="se-ayirici"></div>

        <div class="form-grup">
          <label>Yapılan İşlem</label>
          <div class="input-wrap">
            <textarea nz-input autocomplete="off"
              [ngModel]="p()?.yapilanIslem || ''" (ngModelChange)="guncelle('yapilanIslem', $event)"
              placeholder="Yapılan işlem detayları..." cdkTextareaAutosize [cdkAutosizeMinRows]="2" [cdkAutosizeMaxRows]="4"></textarea>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="se-ayirici"></div>

        <div class="form-grup">
          <label>Sonraki Bakım Tarihi</label>
          <div class="input-wrap">
            <nz-date-picker [ngModel]="p()?.sonrakiBakim" (ngModelChange)="guncelle('sonrakiBakim', $event)"
              nzPlaceHolder="Sonraki bakım tarihi..." style="width:100%"></nz-date-picker>
            <div class="input-glow"></div>
          </div>
          @if (kalanGun() !== null) {
            <div class="stok-uyari" [class.stok-uyari--tehlike]="kalanGun()! <= 0" [class.stok-uyari--uyari]="kalanGun()! > 0 && kalanGun()! <= 7">
              {{ kalanGun()! <= 0 ? '⛔ GECİKME: ' + (-kalanGun()!) + ' gün geçti!' : '⏰ ' + kalanGun() + ' gün kaldı' }}
            </div>
          }
        </div>
      </div>
    </div>
  `,
  styleUrl: './cam-edit.styles.less',
})
export class BakimEditComponent extends FikoYTKokBilesenComponent {
  parametreler = model<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  guncelle(alan: string, deger: any) {
    const params = this.parametreler();
    if (params?.ek) { params.ek[alan] = deger; this.parametreler.set({ ...params }); }
  }
  kalanGun = computed(() => {
    const hedef = this.p()?.sonrakiBakim;
    if (!hedef) return null;
    const fark = new Date(hedef).getTime() - Date.now();
    return Math.ceil(fark / 86400000);
  });
}
